import { render, staticRenderFns } from "./TdxNavigation.vue?vue&type=template&id=106ae4a6&scoped=true&"
import script from "./TdxNavigation.vue?vue&type=script&lang=js&"
export * from "./TdxNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TdxNavigation.vue?vue&type=style&index=0&id=106ae4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106ae4a6",
  null
  
)

export default component.exports